// extracted by mini-css-extract-plugin
module.exports = {"columnNumberTenant":"contractsTable_columnNumberTenant__2SXzb"};